<template>
    <div class="form-element-wrapper" :style="{
        justifyContent: component.customData.alignment || ''
    }">
        <input type="checkbox" id="hasTribute" class="rd-relative" v-model="renderStore.hasTribute">
        <label for="hasTribute" class="rd-text-sm rd-mb-0 rd-ml-2.5">{{ component.customData.tributeOptInText }}</label>
    </div>

    <template v-if="renderStore.hasTribute">
        <div v-if="component.customData.tributeType === TributeType.Both"
            class="form-radio-group rd-inline-flex rd-leading-none" :class="isModalDisplay ? 'rd-mt-3' : 'rd-mt-6'">
            <VueRadioButton id="isInHonorOf" :selected="tributeType === TributeType.InHonorOf"
                :value=TributeType.InHonorOf class="rd-leading-none" name="isInHonorOf" v-model="tributeType"
                labelText="In honor of" :is-admin="false" />

            <VueRadioButton id="isInMemoryOf" :selected="tributeType === TributeType.InMemoryOf"
                :value=TributeType.InMemoryOf class="rd-leading-none rd-ml-5" name="isInMemoryOf" v-model="tributeType"
                labelText="In memory of" :is-admin="false" />
        </div>

        <TributeInputComponent :component="component" />

        <AcknowledgeeInputComponent v-if="component.customData.hasAcknowledgement" :component="component" />
    </template>
</template>

<script lang="ts">
import VueRadioButton from '@/components/shared/form/radio/RadioButton.vue';
import { defineComponent, PropType } from 'vue';
import { TributeType } from '../../enums';
import { useRenderStore } from '../../stores/renderStore';
import AcknowledgeeInputComponent from './AcknowledgeeInputComponent.vue';
import TributeInputComponent from './TributeInputComponent.vue';
import { ITributeComponent } from './TributeInterface';
import { PartialDisplayType } from "@/builder/enums";

export default defineComponent({
    name: "TributeComponent",
    components: {
        VueRadioButton,
        TributeInputComponent,
        AcknowledgeeInputComponent
    },
    props: {
        component: {
            type: Object as PropType<ITributeComponent>,
            required: true
        }
    },
    setup() {
        const renderStore = useRenderStore();
        return { renderStore, TributeType };
    },
    data() {
        return {
            tributeType: TributeType.InHonorOf,
            selectedState: null as string | null,
            selectedCountry: null as string | null,
            states: [] as any[],
            countries: [] as any[],
        }
    },
    computed: {
        isModalDisplay() {
            return this.renderStore.page.partialDisplayType === PartialDisplayType.Modal;
        }
    },
    watch: {
        tributeType: {
            handler(val: TributeType) {
                //set store tribute
                this.renderStore.tribute.isInHonorOf = val === TributeType.InHonorOf;
                this.renderStore.tribute.isInMemoryOf = val === TributeType.InMemoryOf;
            },
        },
        "renderStore.hasTribute": {
            handler(val: boolean) {
                if (!val) {
                    //we need to clear out any store errors for tributes if present
                    const tributeErrors = this.renderStore.errors.filter(x => x.componentId === this.component.id);
                    if (tributeErrors.length > 0) {
                        tributeErrors.forEach(x => {
                            this.renderStore.errors.splice(this.renderStore.errors.indexOf(x), 1);
                        });
                    }
                }
            }
        }
    },
    mounted() {
        this.renderStore.hasTribute = this.component.customData.isChecked;

        //set tribute type
        if (this.component.customData.tributeType === TributeType.Both) {
            this.tributeType = TributeType.InHonorOf;
        } else {
            this.tributeType = this.component.customData.tributeType;
        }

        //set store tribute
        this.renderStore.tribute.isInHonorOf = this.tributeType === TributeType.InHonorOf;
        this.renderStore.tribute.isInMemoryOf = this.tributeType === TributeType.InMemoryOf;
    },
});
</script>
